<template>
  <div>
    <el-card class="filter-card">
      <div class="filter-form">
        <div class="filter-form-left">
          <el-input
            v-model="queryParams.model"
            placeholder="型号"
            clearable
            style="width: 200px; margin-right: 10px;"
          />
          <el-input
            v-model="queryParams.brand"
            placeholder="品牌"
            clearable
            style="width: 200px; margin-right: 10px;"
          />
          <el-input
            v-model="queryParams.chip_spec"
            placeholder="芯片规格"
            clearable
            style="width: 200px; margin-right: 10px;"
          />
          <el-select
            v-model="queryParams.tag_code"
            placeholder="标签"
            clearable
            popper-class="tag-select-dropdown"
            style="width: 180px; margin-right: 10px;"
          >
            <el-option
              v-for="tag in queryTagOptions"
              :key="tag.code"
              :label="getTagPrimaryText(tag)"
              :value="tag.code"
            >
              <div class="tag-option">
                <div class="tag-option-main">{{ getTagPrimaryText(tag) }}</div>
                <div class="tag-option-sub">{{ getTagSecondaryText(tag) }}</div>
              </div>
            </el-option>
          </el-select>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </div>
        <el-button type="primary" @click="openAddDialog">新增</el-button>
      </div>
    </el-card>

    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="products"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="model" label="型号" width="250" />
        <el-table-column prop="tag_code" label="标签" width="100">
          <template #default="{ row }">
            <el-tag size="small">
              {{ row.tag_code || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="chip_spec" label="芯片规格" width="200">
          <template #default="{ row }">
            <div class="content-preview">{{ row.chip_spec || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="memory_spec" label="内存规格" width="200">
          <template #default="{ row }">
            <div class="content-preview">{{ row.memory_spec || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌" width="150" />
        <el-table-column prop="synonyms" label="同义词" min-width="200">
          <template #default="{ row }">
            <div class="content-preview">{{ row.synonyms || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="{ row }">
            {{ row.created_at }}
          </template>
        </el-table-column>
        <el-table-column prop="updated_at" label="更新时间" width="180">
          <template #default="{ row }">
            {{ row.updated_at }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template #default="{ row }">
            <el-button size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button size="small" style="color: #f56c6c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <el-dialog v-model="addDialogVisible" title="新增型号" width="600px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="型号" prop="model">
          <el-input v-model="form.model" placeholder="请输入型号" />
        </el-form-item>
        <el-form-item label="标签" prop="tag_code">
          <el-select
            v-model="form.tag_code"
            placeholder="请选择标签"
            popper-class="tag-select-dropdown"
            style="width: 100%;"
          >
            <el-option
              v-for="tag in tagOptions"
              :key="tag.code"
              :label="getTagPrimaryText(tag)"
              :value="tag.code"
            >
              <div class="tag-option">
                <div class="tag-option-main">{{ getTagPrimaryText(tag) }}</div>
                <div class="tag-option-sub">{{ getTagSecondaryText(tag) }}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="芯片规格" prop="chip_spec">
          <el-input v-model="form.chip_spec" placeholder="请输入芯片规格" />
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="form.brand" placeholder="请输入品牌（可选）" />
        </el-form-item>
        <el-form-item label="内存规格">
          <el-input v-model="form.memory_spec" placeholder="请输入内存规格（可选）" />
        </el-form-item>
        <el-form-item label="同义词" prop="synonyms">
          <el-input
            v-model="form.synonyms"
            type="textarea"
            :rows="3"
            placeholder="请输入产品同义词, 多个用逗号分隔"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAdd">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog v-model="editDialogVisible" title="编辑产品" width="600px">
      <el-form ref="editFormRef" :model="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="型号" prop="model">
          <el-input v-model="editForm.model" placeholder="请输入型号" />
        </el-form-item>
        <el-form-item label="标签" prop="tag_code">
          <el-select
            v-model="editForm.tag_code"
            placeholder="请选择标签"
            popper-class="tag-select-dropdown"
            style="width: 100%;"
          >
            <el-option
              v-for="tag in tagOptions"
              :key="tag.code"
              :label="getTagPrimaryText(tag)"
              :value="tag.code"
            >
              <div class="tag-option">
                <div class="tag-option-main">{{ getTagPrimaryText(tag) }}</div>
                <div class="tag-option-sub">{{ getTagSecondaryText(tag) }}</div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="芯片规格" prop="chip_spec">
          <el-input v-model="editForm.chip_spec" placeholder="请输入芯片规格" />
        </el-form-item>
        <el-form-item label="品牌">
          <el-input v-model="editForm.brand" placeholder="请输入品牌（可选）" />
        </el-form-item>
        <el-form-item label="内存规格">
          <el-input v-model="editForm.memory_spec" placeholder="请输入内存规格（可选）" />
        </el-form-item>
        <el-form-item label="同义词" prop="synonyms">
          <el-input
            v-model="editForm.synonyms"
            type="textarea"
            :rows="3"
            placeholder="请输入产品同义词, 多个用逗号分隔"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEdit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import { getProducts, createProduct, getProduct, updateProduct, deleteProduct } from '@/services/product'
import { getProductTags } from '@/services/productTag'
import { ElMessage, ElMessageBox } from 'element-plus'
import { extractErrorMessage } from '@/utils/errorHandler'

export default {
  name: 'ProductMgmt',
  setup() {
    const EMPTY_TAG_QUERY_VALUE = '-'
    const loading = ref(false)
    const products = ref([])
    const tagOptions = ref([])
    const allTagOptions = ref([])
    const queryTagOptions = computed(() => [
      {
        code: EMPTY_TAG_QUERY_VALUE,
        remark: '待设置',
        is_query_empty_option: true
      },
      ...allTagOptions.value
    ])
    const total = ref(0)
    const currentPage = ref(1)
    const pageSize = ref(20)
    const queryParams = ref({
      model: '',
      brand: '',
      chip_spec: '',
      tag_code: ''
    })

    const addDialogVisible = ref(false)
    const formRef = ref(null)
    const form = ref({
      model: '',
      brand: '',
      tag_code: '',
      chip_spec: '',
      memory_spec: '',
      synonyms: ''
    })
    const rules = {
      model: [
        { required: true, message: '请输入型号', trigger: 'blur' }
      ],
      tag_code: [
        { required: true, message: '请选择标签', trigger: 'change' }
      ],
      chip_spec: [
        { required: true, message: '请输入芯片规格', trigger: 'blur' }
      ]
    }

    const editDialogVisible = ref(false)
    const editFormRef = ref(null)
    const currentEditId = ref(null)
    const editForm = ref({
      model: '',
      brand: '',
      tag_code: '',
      chip_spec: '',
      memory_spec: '',
      synonyms: ''
    })
    const editRules = {
      model: [
        { required: true, message: '请输入型号', trigger: 'blur' }
      ],
      brand: [
        { required: true, message: '请输入品牌', trigger: 'blur' }
      ],
      tag_code: [
        { required: true, message: '请选择标签', trigger: 'change' }
      ],
      chip_spec: [
        { required: true, message: '请输入芯片规格', trigger: 'blur' }
      ]
    }

    const fetchTags = async () => {
      try {
        const activeData = await getProductTags({
          is_active: true,
          skip: 0,
          limit: 1000
        })
        tagOptions.value = activeData.tags || []

        const allData = await getProductTags({
          skip: 0,
          limit: 1000
        })
        allTagOptions.value = allData.tags || []
      } catch (error) {
        console.error('获取标签列表失败:', error)
        ElMessage.error(extractErrorMessage(error, '获取标签列表失败'))
      }
    }

    const normalizeTagCode = (code) => {
      if (!code) return ''
      return String(code).trim().toUpperCase()
    }

    const isEmptyTagQueryOption = (tag) => Boolean(tag && tag.is_query_empty_option)

    const getTagPrimaryText = (tag) => {
      if (isEmptyTagQueryOption(tag)) return '空'
      if (!tag || !tag.code) return '-'
      return normalizeTagCode(tag.code)
    }

    const getTagSecondaryText = (tag) => {
      if (isEmptyTagQueryOption(tag)) return '待设置'
      if (!tag || !tag.code) return '-'
      const code = normalizeTagCode(tag.code)
      const desc = (tag.remark || '').trim()
      return desc ? `${code}-${desc}` : code
    }

    const fetchProducts = async () => {
      loading.value = true
      try {
        const params = {
          skip: (currentPage.value - 1) * pageSize.value,
          limit: pageSize.value,
          ...queryParams.value
        }
        Object.keys(params).forEach(key => {
          if (params[key] === '') {
            delete params[key]
          }
        })

        const data = await getProducts(params)
        products.value = data.products || []
        total.value = data.total || 0
      } catch (error) {
        console.error('获取产品列表失败:', error)
        ElMessage.error(extractErrorMessage(error, '获取产品列表失败'))
      } finally {
        loading.value = false
      }
    }

    const handleSizeChange = (size) => {
      pageSize.value = size
      currentPage.value = 1
      fetchProducts()
    }

    const handleCurrentChange = (page) => {
      currentPage.value = page
      fetchProducts()
    }

    const handleSearch = () => {
      currentPage.value = 1
      fetchProducts()
    }

    const resetSearch = () => {
      queryParams.value = {
        model: '',
        brand: '',
        chip_spec: '',
        tag_code: ''
      }
      currentPage.value = 1
      fetchProducts()
    }

    const openAddDialog = () => {
      addDialogVisible.value = true
      form.value = {
        model: '',
        brand: '',
        tag_code: '',
        chip_spec: '',
        memory_spec: '',
        synonyms: ''
      }
      if (formRef.value) {
        formRef.value.clearValidate()
      }
    }

    const submitAdd = async () => {
      if (!formRef.value) return
      try {
        await formRef.value.validate()
      } catch (error) {
        return
      }
      try {
        await createProduct(form.value)
        ElMessage.success('产品创建成功')
        addDialogVisible.value = false
        fetchProducts()
      } catch (error) {
        console.error('创建产品失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const openEditDialog = async (row) => {
      editDialogVisible.value = true
      currentEditId.value = row.id

      editForm.value = {
        model: row.model || '',
        brand: row.brand || '',
        tag_code: row.tag_code || '',
        chip_spec: row.chip_spec || '',
        memory_spec: row.memory_spec || '',
        synonyms: row.synonyms || ''
      }

      if (editFormRef.value) {
        editFormRef.value.clearValidate()
      }

      try {
        const productData = await getProduct(row.id)
        editForm.value = {
          model: productData.model || '',
          brand: productData.brand || '',
          tag_code: productData.tag_code || '',
          chip_spec: productData.chip_spec || '',
          memory_spec: productData.memory_spec || '',
          synonyms: productData.synonyms || ''
        }
      } catch (error) {
        console.error('获取产品详情失败:', error)
        ElMessage.warning('获取产品详情失败，显示部分信息')
      }
    }

    const submitEdit = async () => {
      if (!editFormRef.value) return
      try {
        await editFormRef.value.validate()
      } catch (error) {
        return
      }
      try {
        await updateProduct(currentEditId.value, editForm.value)
        ElMessage.success('产品更新成功')
        editDialogVisible.value = false
        fetchProducts()
      } catch (error) {
        console.error('更新产品失败:', error)
        ElMessage.error(extractErrorMessage(error))
      }
    }

    const handleEdit = (row) => {
      openEditDialog(row)
    }

    const handleDelete = (row) => {
      ElMessageBox.confirm(
        `确认删除产品"${row.model}"吗？此操作不可恢复。`,
        '删除确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async () => {
        try {
          await deleteProduct(row.id)
          ElMessage.success('删除成功')
          fetchProducts()
        } catch (error) {
          console.error('删除产品失败:', error)
          ElMessage.error(extractErrorMessage(error))
        }
      }).catch(() => {
        // 用户取消删除
      })
    }

    onMounted(async () => {
      await fetchTags()
      fetchProducts()
    })

    return {
      loading,
      products,
      tagOptions,
      allTagOptions,
      queryTagOptions,
      total,
      currentPage,
      pageSize,
      queryParams,
      addDialogVisible,
      form,
      rules,
      formRef,
      editDialogVisible,
      editForm,
      editRules,
      editFormRef,
      handleSizeChange,
      handleCurrentChange,
      handleSearch,
      resetSearch,
      openAddDialog,
      submitAdd,
      openEditDialog,
      submitEdit,
      handleEdit,
      handleDelete,
      getTagPrimaryText,
      getTagSecondaryText
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 10px;
}
.filter-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.filter-form-left {
  display: flex;
  align-items: center;
}
.table-card {
  margin-bottom: 10px;
}
.content-preview {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
